import {useCallback} from 'react';
import {AllCodeListIdsScopeMap} from 'schemaDefinition/types';
import {useAppDispatch} from 'store/hooks';
import type {CodeListId} from '../types';
import {useLazyGetCodelistQuery} from '../codelistApi';
import {loadCodelist} from '../codelistsSlice';

export const useLoadCodelist = () => {
  const dispatch = useAppDispatch();
  const [trigger] = useLazyGetCodelistQuery();

  return useCallback(
    (id: CodeListId, language: string) => {
      if (AllCodeListIdsScopeMap[id] !== 'local') {
        dispatch(
          loadCodelist({
            id,
            data: {
              status: 'Loading',
            },
          }),
        );

        trigger({id, language})
          .unwrap()
          .then(data => {
            dispatch(
              loadCodelist({
                id,
                data: {
                  status: 'Loaded',
                  data,
                },
              }),
            );
          })
          .catch(error => {
            dispatch(
              loadCodelist({
                id,
                data: {
                  status: 'Failed',
                  error: error,
                },
              }),
            );
          });
      }
    },
    [dispatch, trigger],
  );
};
